<app-breadcrumb [master]="'Administracja'" [parentName]="'Hiperio'" [name]="'Wnioski o zmianę loginu'"></app-breadcrumb>
<div class="hiperio-conclude-change-registration-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="hiperio-conclude-change-registration-list-filters">
    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="hiperio-conclude-change-registration-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="hiperio-conclude-change-registration-list-filter "
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>


    <app-datepicker
      class="hiperio-conclude-change-registration-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="hiperio-conclude-change-registration-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'hiperio_test_access_form_status'"
      [label]="'Status'" class="hiperio-conclude-change-registration-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek)"
      class="hiperio-conclude-change-registration-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-insurance-companies
      [multiple]="false" label="TU" class="hiperio-conclude-change-registration-list-filter"
      [(ngModel)]="initialFilters.insuranceCompany"
      name="insuranceCompany"
    ></app-dict-insurance-companies>


  </form>

  <div class="hiperio-conclude-change-registration-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="jobs" >

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy?.firstName}} {{element.createdBy?.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="!element.createdBy">
          System
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.ofwca">
          <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca?.fullName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="registrationBefore">
      <th mat-header-cell *matHeaderCellDef> Rejestracja przed </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.registrationBefore">
          <a class="default-link" [routerLink]="['/rejestracje/szczegoly', element.registrationBefore?.uuid]">
            {{element.registrationBefore?.insuranceCompany?.name}}  {{ element.registrationBefore?.ofwca?.fullName }}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="registrationAfter">
      <th mat-header-cell *matHeaderCellDef> Rejestracja po </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.registrationAfter">
          <a class="default-link" [routerLink]="['/rejestracje/szczegoly', element.registrationAfter?.uuid]">
            {{element.registrationAfter?.insuranceCompany?.name}}  {{ element.registrationAfter?.ofwca?.fullName }}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="TU">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.hiperioConfig?.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.hiperioConfig?.insuranceCompany?.id]">
          {{element.hiperioConfig?.insuranceCompany?.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="(userPermissions | async).hiperio?.write && element.status.key === HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING" (click)="changeStatus(element.uuid, HIPERIO_TEST_ACCESS_FORM_STATUS_ACCEPTED)" mat-button color="accent"><mat-icon>check</mat-icon></button>
        <button *ngIf="(userPermissions | async).hiperio?.write && element.status.key === HIPERIO_TEST_ACCESS_FORM_STATUS_PENDING" (click)="changeStatus(element.uuid, HIPERIO_TEST_ACCESS_FORM_STATUS_REJECTION)" mat-button  color="warn"><mat-icon>close</mat-icon></button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
